var _path, _line, _line2, _line3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 2,
    stroke: "#000",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.13,37.74,16.62,54.46,14.69,49s4.08-2.13,2.74-5.84-6.19-2.9-6.19-2.9L9.35,34.64,51,18.21l2.06,4.87S48.62,25.79,50,29.63s6.25,2.94,6.25,2.94Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18.5,
    y1: 31.04,
    x2: 20.77,
    y2: 36.18,
    strokeDasharray: "9 4"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21.83,
    y1: 38.65,
    x2: 23.75,
    y2: 42.99,
    strokeDasharray: "9 4"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 24.47,
    y1: 45.04,
    x2: 26.75,
    y2: 50.18,
    strokeDasharray: "9 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4,34.54,41.52,10.71l3.38,4.06s-3.47,3.89-1,7.15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketSvgrepoCom);
export default __webpack_public_path__ + "static/media/ticket-svgrepo-com.49f4706ef86fc3f50cfc57fb8aeacc5d.svg";
export { ForwardRef as ReactComponent };